import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Divider,
  Box,
  Button,
  IconButton,
  CircularProgress,
  Typography
} from "@mui/material";
import { Close, PhotoCamera } from "@mui/icons-material";
import { MentionsInput, Mention } from "react-mentions";
import { mentionsStylePost } from "./mentionsStyles";

const EditPostModal = ({
  open,
  onClose,
  content,
  setContent,
  imageUrl,
  setImageUrl,
  onUpdate,
  isUploading,
  queryUsers,
}) => {
  // Manejo de cambio de archivo
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Llamamos a onUpdate del SocialManager con el flag de solo subir
      onUpdate(file, true);
      // Limpiamos el valor para permitir subir el mismo archivo si se borra
      e.target.value = null;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={isUploading ? null : onClose} // Bloquea cierre manual si está subiendo
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: { borderRadius: 2, zIndex: 10000 } }}
      sx={{ zIndex: 9999 }}
      disableEscapeKeyDown={isUploading} // Evita cerrar con tecla ESC si sube
    >
      <DialogTitle sx={{ 
        textAlign: "center", 
        fontWeight: 700,
        position: 'relative' 
      }}>
        Editar publicación
        {!isUploading && (
          <IconButton
            onClick={onClose}
            sx={{ position: 'absolute', right: 12, top: 12, color: '#65676b' }}
          >
            <Close />
          </IconButton>
        )}
      </DialogTitle>
      
      <Divider />
      
      <Box sx={{ p: 2 }}>
        {/* Área de Texto con Menciones */}
        <Box sx={{ 
          minHeight: 100, 
          maxHeight: 200, 
          overflowY: 'auto',
          mb: 2 
        }}>
          <MentionsInput
            value={content}
            onChange={(e) => setContent(e.target.value)}
            style={mentionsStylePost}
            placeholder="¿Qué estás pensando?"
            disabled={isUploading}
          >
            <Mention
              trigger="@"
              data={queryUsers}
              markup="@[__display__](__id__)"
              style={mentionsStylePost.mention}
            />
          </MentionsInput>
        </Box>

        {/* Visualización de Imagen / Botón de subida */}
        {imageUrl ? (
          <Box sx={{ position: "relative", mt: 1, borderRadius: 2, overflow: 'hidden' }}>
            <img
              src={imageUrl}
              alt="Vista previa"
              style={{
                width: "100%",
                display: 'block',
                maxHeight: 350,
                objectFit: "contain",
                backgroundColor: '#f0f2f5'
              }}
            />
            {!isUploading && (
              <IconButton
                onClick={() => setImageUrl("")}
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  bgcolor: "rgba(0,0,0,0.6)",
                  color: "#fff",
                  '&:hover': { bgcolor: "rgba(0,0,0,0.8)" }
                }}
              >
                <Close fontSize="small" />
              </IconButton>
            )}
            {isUploading && (
              <Box sx={{
                position: 'absolute',
                inset: 0,
                bgcolor: 'rgba(255,255,255,0.7)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <CircularProgress size={40} />
              </Box>
            )}
          </Box>
        ) : (
          <Button
            fullWidth
            variant="outlined"
            component="label"
            disabled={isUploading}
            startIcon={isUploading ? <CircularProgress size={20} color="inherit" /> : <PhotoCamera />}
            sx={{ 
              borderStyle: "dashed", 
              borderWidth: 2,
              py: 5, 
              color: "#65676b",
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              '&:hover': { borderStyle: 'dashed', bgcolor: '#f0f2f5' }
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {isUploading ? "Procesando imagen..." : "Agregar una foto"}
            </Typography>
            <input
              hidden
              type="file"
              accept="image/*"
              onChange={handleFileChange}
            />
          </Button>
        )}
      </Box>

      <DialogActions sx={{ p: 2, borderTop: '1px solid #e4e6eb' }}>
        <Button 
          onClick={onClose} 
          disabled={isUploading} 
          sx={{ color: '#1877f2', fontWeight: 600, textTransform: 'none' }}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={() => onUpdate()} // Ejecuta handleUpdatePost final
          disabled={isUploading || (!content.trim() && !imageUrl)}
          sx={{ 
            bgcolor: "#1877f2", 
            px: 4, 
            fontWeight: 600,
            textTransform: 'none',
            borderRadius: 1.5,
            boxShadow: 'none',
            '&:hover': { bgcolor: '#166fe5', boxShadow: 'none' },
            '&:disabled': { bgcolor: '#e4e6eb', color: '#bcc0c4' }
          }}
        >
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditPostModal;